import { TableRow, TableRowProps } from "@mui/material";
import { ReactNode } from "react";
import Draggable from "../Draggable";

type DataTableRowProps = (
  | {
      isDraggable: true;
      id: string;
    }
  | {
      isDraggable?: false;
      id?: never;
    }
) & {
  children: ReactNode;
} & Omit<TableRowProps, "draggable">;

const DataTableRow = ({
  id,
  isDraggable,
  children,
  ...props
}: DataTableRowProps) => {
  if (isDraggable) {
    return (
      <Draggable as={TableRow} id={id} {...props}>
        {children}
      </Draggable>
    );
  }

  return <TableRow {...props}>{children}</TableRow>;
};

export default DataTableRow;
